"use client";

import { useNavigate } from "react-router";
import Icon from "../components/Icon";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Row, Col, Container } from "react-bootstrap";

export default function RefundPage() {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <Container fluid>
            <Row>
                <Col>
                    <div className="mt-4 mb-5">
                        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                            <h2 className="mb-0">Правила возврата денежных средств</h2>
                            <button
                                className="btn btn-outline-secondary"
                                onClick={handleGoBack}
                                aria-label="Вернуться назад"
                            >
                                <Icon icon={faTimes} />
                            </button>
                        </div>

                        <div className="mb-3 text-muted">
                            <strong>Дата вступления в силу:</strong> 25.07.2026
                        </div>

                        <p>
                            Настоящие Правила определяют порядок возврата денежных средств за услуги сервиса «Артефакты» (далее — «Сервис»).
                        </p>

                        <h3>1. Общие положения</h3>
                        <p>Возврат денежных средств осуществляется в соответствии с законодательством Российской Федерации и настоящими Правилами.</p>

                        <h3>2. Срок возврата</h3>
                        <p>
                            Пользователь вправе отказаться от использования Сервиса и потребовать возврат уплаченных денежных средств <strong>в течение 5 (пяти) календарных дней с момента оплаты</strong>.
                        </p>
                        <p>
                            По истечении указанного срока денежные средства возврату не подлежат, если иное не предусмотрено законодательством Российской Федерации.
                        </p>

                        <h3>3. Порядок оформления возврата</h3>
                        <p>Для оформления возврата Пользователь направляет запрос на электронную почту:</p>
                        <p><strong>E-mail:</strong> staff@insight-systems.ru</p>
                        <p>В запросе необходимо указать:</p>
                        <ul>
                            <li>адрес электронной почты, использованный при регистрации;</li>
                            <li>дату оплаты;</li>
                            <li>сумму платежа;</li>
                            <li>при наличии — номер заказа или идентификатор платежа;</li>
                            <li>причину обращения (по желанию).</li>
                        </ul>

                        <h3>4. Рассмотрение заявления</h3>
                        <p>Запрос на возврат рассматривается Оператором в течение <strong>5 (пяти) рабочих дней</strong> с момента его получения.</p>
                        <p>При необходимости Оператор вправе запросить дополнительные сведения, подтверждающие факт оплаты.</p>

                        <h3>5. Порядок возврата денежных средств</h3>
                        <p>Возврат производится тем же способом, которым была произведена оплата, если иной способ не согласован с Пользователем и не допускается законодательством Российской Федерации.</p>
                        <p>Срок зачисления денежных средств зависит от банка или платежной системы и может составлять до <strong>10 рабочих дней</strong> после осуществления возврата Оператором.</p>

                        <h3>6. Контактная информация</h3>
                        <p>По вопросам возврата денежных средств Пользователь может обратиться:</p>
                        <ul>
                            <li><strong>Оператор:</strong> Коледина Антонина Владимировна</li>
                            <li><strong>Статус:</strong> Самозанятый</li>
                            <li><strong>E-mail:</strong> staff@insight-systems.ru</li>
                            <li><strong>Дата последнего обновления:</strong> 25.07.2026</li>
                        </ul>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}
